
<template>
  <div class="ConfigPrivilege">
    <div class="status">
      <div class="LeftPart">
        <h1 style="color: white;font-size: larger" > 当前用户  :{{this.userinfo.username}}</h1>
      </div>
      <div class="RightPart">
        <el-button  type="primary"   size="small" >数据刷新时间：{{dataTableUpdataTime}}</el-button>
        <el-button type="success" size="small" @click="batchConfirm(selectedTableData)" :loading="confirmLoading" >批量授权</el-button>
        <el-button type="primary" size="small" @click="changeShowAuthorized" >隐藏(显示)已授权</el-button>
      </div>
    </div>
    <div class="statusTable">
      <!-- el-tabel设置height就会出现滚动条且表头跟着滚动条移动 -->
      <el-table
          :data="companydata "
          @selection-change="handleSelectionChange"
          height="100%">
        <el-table-column type="selection" width="55" />
        <el-table-column
            type="index"
            :index ="setMenuIndex"
            width="80px"
            label="序号">
        </el-table-column>
        <el-table-column
            prop="groupname"
            label="集团"
            sortable>
        </el-table-column>
        <el-table-column
            prop="companyname"
            label="分公司"
            sortable>
        </el-table-column>
        <el-table-column
            label="授权状态"
            width="100px">
          <template #default="scope">
            <div v-if="scope.row.authorized===false">
              <el-button   type="text"  style="color: red">未授权</el-button>
            </div>
            <div v-else>
              <el-button  type="text" style="color:green;">已授权</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <SensorPoints v-model="SensorPointsContent.flag" :SensorPointsContent="SensorPointsContent"></SensorPoints>
  </div>
</template>

<script>
import {ref, onBeforeMount ,onBeforeUnmount, computed,onMounted, watch,router,nextTick,h} from 'vue'
import { ElMessageBox, ElLoading ,ElMessage} from 'element-plus'
import {useStore} from 'vuex'
import {useRoute, useRouter} from 'vue-router'
import axios from 'axios'

import SensorPoints from '../components/charts/SensorPoints.vue'
import {export_json_to_excel} from "../components/ExportFiles/Export2Excel";
export default {
  name: 'ConfigPrivilege',
  components:{

    SensorPoints
  },
  setup(props, ctx){
    var CancelToken = axios.CancelToken;
    var source = CancelToken.source();
    let Requests=[0,0,0];
    let showConfirm=ref('empty');

    let showAuthorized=ref(true);

    let SensorPointsContent=ref({
      points:null,
      row:null,
      flag:false
    });
    let companydata = ref([{groupname:'',companyname:'',authorized:false}]);
    let dataSource=ref('4');
    let activeIndex = ref('全部');
    let tableData = ref([]);
    let selectedTableData = ref([]);
    let trendInfo = {};
    let tmpTableData = ref([]);
    let userinfo =  ref({
      username: '',
      usernickname: '',
      privilege: '',
      password:''
    })
    let search = ref('');
    let value = ref(10);  //每页显示的行数。
    let totalNum = ref(0);
    let currentPage = ref(1);
    let outExcelLoading = ref(false);
    let confirmLoading = ref(false)
    let treeWidth = computed(() => {
      return store.state.contentWidth;
    })
    let store = useStore();     ///使用vuex中的内容
    let dataTableUpdataTime = ref(new Date().getDate());
    let setMenuIndex =((index) => {     ///计算表格中的序号
                                        // console.log(value)
      return index+1+value.value*(currentPage.value-1)
    })
    let options = ref([
      {
        value: 10,
        label: 10
      },
      {
        value: 15,
        label: 15
      },
      {
        value: 25,
        label: 25
      },
      {
        value: 50,
        label: 50
      },
      {
        value: 100,
        label: 100
      }
    ])
    let formatJson = (filterVal, jsonData) => {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }

    let stateRes = {};

    let router = useRouter();

    /**
     * 获取所有的异常数据
     * @type {getAllData}
     */

    let getAllData = (() => {
      // let url='/api1/data/rt/allSelected'
      let info = store.state.nodeData
      let url = '/api1/data/rt/allSelected';
      for(let i=0;i<5;i++){
        // url += '/'+info.node[i]
        url += '/'+encodeURIComponent(info.node[i]).replace('%2F', '%252f');
      }
      console.log('info.node',info.node);
      //区分无线和有线设备
      url+='/'+dataSource.value;
      //区分显示或隐藏已确认
      url+='/'+showConfirm.value;


      return axios.get(url+'/'+(search.value==''?'empty':search.value)).then( res => {
        // console.log('all', res)
        let data = res.data.data;
        return data
      })
    })


    let timeControl = setInterval(()=>{   ///定时获取数据
      getTableData();
    },1000*60);
    watch(() => store.state.nodeLable, () => {
      console.log('点击了设备树');
      let items = tmpTableData.value;
      getDataByGroupname()
    })
    watch(() =>value,() =>{
      console.log('监听');
      tableData();
    })

    let timestampToTime = (timestamp) => {
      let date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()) + '';
      let ms = (timestamp % 1000).toString()
      while (ms.length < 3) {
        ms = '0' + ms
      }
      return Y + M + D + h + m + s ;
    }


    let handleSelectionChange =(val) =>{
      console.log('handleSelectionChange',val);
      selectedTableData.value=val;
    }
    let initUser= ( () =>{

      userinfo.value.username = store.state.username;
      userinfo.value.password = store.state.password;
      userinfo.value.usernickname = store.state.usernickname;
      userinfo.value.privilege = store.state.privilege;

      if(store.state.username == '' ||store.state.username == null)
      {
        ElMessage.error("请选用户")
        router.push("/UserManage")
      }

    })
    let getDataByGroupname=(() =>{
      dataTableUpdataTime.value = timestampToTime( new Date());
      let info = store.state.nodeData
      let url = '/api1/companys/getDataByGroupname';
      url += '/'+encodeURIComponent(info.node[0]).replace('%2F', '%252f');
      url += '/'+store.state.username;
      axios.get(url).then((res)=>{
        var tmpcompanydata = [];
        let obj = JSON.parse(res.data.data);

        Object.keys(obj).forEach(value1 => {
          let o ={};
          o.groupname = info.node[0];
          o.companyname = value1;
          o.authorized = obj[value1];
          console.log(showAuthorized.value)
          if(showAuthorized.value)
          {
            tmpcompanydata.push(o);
          }
          else if(!o.authorized)
          {
            tmpcompanydata.push(o);
          }
        })
        companydata.value = tmpcompanydata;
        console.log(companydata.value);
        filterTablePageNum.value = tmpcompanydata.length;
        }
      )
    } )


    let getTableData = (() =>{      ///开始获取数据表

    })

    let handleCurrentChange = ((val) => {       ///更改页码，跳转到对应的第val的页
      currentPage.value = val;
      getDataByGroupname();
      getTableData()
    })
    //更新未确认/已确认的状态
    let updateIsConfirm = ((row) => {
      let val=row.id;
      let string='设备:'+row.equipmentName
          +'<br>测点:'+row.pointName
          +'<br>异常状态:'+row.status
          +'<br>时间:'+row.updateTime
      ElMessageBox({
        title: '更改确认状态',
        message: h('p', null, [
          h('p', null, '设备:'+row.equipmentName),
          h('p', null, '测点:'+row.pointName),
          h('p', null, '异常状态:'+row.status),
          h('p', null, '时间:'+row.updateTime),
        ]),
        showCancelButton: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            let url = '/api1/data/updateIsConfirm/';
            url+=val;
            console.log('row',row);
            let isConfirm=row.isConfirm==0?1:0;
            url+='/'+isConfirm;
            axios.get(url).then((res)=>{
              // console.log(res);
              if(res.data.code==200)
              {
                getTableData();
                ElMessage({
                  message: '确认状态更新成功.',
                  type: 'success',
                })
                done()
              }
              else
              {
                ElMessage({
                  message: '确认状态更新失败！',
                  type: 'warning',
                })
                done()
              }
            })

          } else {
            ElMessage({
              message: '取消更新确认状态.',
              type: 'info',
            })
            done()
          }
        },
      })
    })
    let handleEdit = ((index, row) => {
      row.NowStatus =(new Date().valueOf() -  new Date(row.startTime).valueOf());
      row.day= row.NowStatus/(1000*60*60*24);
      if(row.day <1) row.day='';
      row.NowStatus%=(1000*60*60*24);
      row.house = row.NowStatus/(1000*60*60);
      row.NowStatus%=(1000*60*60);
      row.min = row.NowStatus/(1000*(60));

      let message = '报警状态：' + row['status'] + '<br>' + '故障时间：' + row['startTime'] + '<br>' + '目前状态：已出故障 '+row.NowStatus+' <br> 邮件状态：已发送邮件到：123456@mail.com';
      if (row['status'] == '电池电量报警') {
        message = '电池状态：电池电量过低<br>低于报警限制：2021.12.31 12:33<br>电池电量：7%<br>邮件状态：已发送邮件到：123456@mail.com';
      }
      ElMessageBox.alert(message, '详细信息', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        callback: (action) => {
          // ElMessage({
          //   type: 'info',
          //   // message: `action: ${action}`,
          // })
        },
      })
    })
    let allNum = ref(stateRes.all);
    let norNum = ref(stateRes.normal);
    let dataNum =ref(stateRes.all);
    let timeNoChangeNum = ref(stateRes.timeNotChange)
    let valueNoChangeNum = ref(stateRes.valueNotChange)
    let waveNum = ref(stateRes.alarmDataNoWave);
    let alarmNum =  ref(stateRes.alarmDataNoWave);
    let equipNum = computed(() => {
      return tmpTableData.value.filter((item) => {
        return item['status'].search('设备报警') !=-1 && Object.keys(item).some((keys) => {
          if (!store.state.nodeLable) {
            return true;
          } else {
            return item[keys] == store.state.nodeLable;
          }
        }) && Object.keys(item).some((key1) => {
          if (!search) {
            return true;
          }
          return String(item[key1])
              .toLowerCase()
              .match(search.value);
        });
      }).length
    });
    let nodeNum = computed(() => {
      return tmpTableData.value.filter((item) => {
        return item['status'].search('节点异常')!=-1 && Object.keys(item).some((keys) => {
          if (!store.state.nodeLable) {
            return true;
          } else {
            return item[keys] == store.state.nodeLable;
          }
        }) && Object.keys(item).some((key1) => {
          if (!search) {
            return true;
          }
          return String(item[key1])
              .toLowerCase()
              .match(search.value);
        });
      }).length
    });
    let batteryNum = ref(0);
    let filterTable = computed(() => {
      let input = search.value && search.value.toLowerCase();
      let items = tableData.value;
      //区分有线和无线设备，过滤一下
      items=items.filter(function(item){
        return item.dataSource == dataSource.value;
      })
      let items1;
      if (input) {
        items1 = items.filter((item) => {
          return Object.keys(item).some((key1) => {
            return String(item[key1])
                .toLowerCase()
                .match(input);
          })
        })
      } else {
        items1 = items;
      }
      return items1;
    })
    let filterTablePageNum = ref(0);   ///获取活动状态的总页码数量；

    let changeShowConfirm =() =>{
      console.log('showConfirm',showConfirm.value);
      if(showConfirm.value=='empty')
      {
        showConfirm.value=0;
      }else{
        showConfirm.value='empty';
      }
      getTableData();
      // showConfirm.value=!showConfirm.value;
    }

    let changeShowAuthorized = () =>{
      console.log(showAuthorized.value)
      if (showAuthorized.value == true)
      {
        showAuthorized.value = false;
      }
      else {
        showAuthorized.value = true;
      }
      getDataByGroupname();
    }

    let batchConfirm=(vals)=>{

      let userdata = userinfo.value;
      let tmpprivilege = userdata.privilege;
      let oldprivilege = tmpprivilege.substring(0,tmpprivilege.length-2);
      vals.forEach( element =>{
        if(element.authorized == false)
        {
          oldprivilege = oldprivilege + ",'" + element.companyname + "'";
        }
      })
      oldprivilege +="]'";
      userdata.privilege = oldprivilege;
      userdata.isadmin = 0;
      console.log(userdata);
      let userdataJSON = JSON.stringify(userdata)
      axios.post('/api1/edituser', userdata,{
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => {
        let data = res.data
        if(data.code === 200) {
          getDataByGroupname();
        } else {
          ElMessage.error(data.message)
        }
      })
    }

    onBeforeUnmount(()=>{
      window.clearInterval(timeControl)
      source.cancel('取消上一次的请求.')
    })
    onMounted(() => {
      getDataByGroupname();
      getTableData();
      initUser()
    })
    return {
      SensorPointsContent,
      handleSelectionChange,
      changeShowConfirm,
      changeShowAuthorized,
      batchConfirm,
      showConfirm,
      selectedTableData,
      userinfo,
      initUser,
      timeControl,
      allNum,
      norNum,
      dataNum,
      waveNum,
      alarmNum,
      equipNum,
      nodeNum,
      batteryNum,
      timeNoChangeNum,
      valueNoChangeNum,
      tableData,
      search,
      options,
      value,
      totalNum,
      currentPage,
      outExcelLoading,
      filterTable,
      companydata,
      tmpTableData,
      dataTableUpdataTime,
      treeWidth,

      getTableData,
      handleCurrentChange,
      handleEdit,

      stateRes,
      filterTablePageNum,///表格的页码数量
      setMenuIndex,

      updateIsConfirm,
      confirmLoading
    }
  }
}
</script>

<style lang="scss">
.ConfigPrivilege{
  width: calc(100% - v-bind(treeWidth));
  margin-right: 10px;
  height: calc(100vh - 70px);
  margin-bottom: 10px;
  background-color: #303749;
  // background-color: #bfa;

  span.el-dialog__title {
    color: white;
  }
  textarea.el-textarea__inner {
    background-color: #2c3242;
    color: white;
  }
  .status{
    height: 5%;

    margin-left: 10px;
    margin-right: 10px;
    margin-top: 10px;
    position: relative;
    .el-menu{

      height: 100%;
      background-color: #2c3242;
      border-bottom: 0px;
      display: flex;
      align-items: center; //垂直居中
      // justify-content: center;
      .el-menu-item.hItem{
        font-size: 20px;
      }

    }
    .LeftPart{
      position: absolute;
      top: 5px;
      left:10px;
      display: flex;
      align-items: center;
    }
    .RightPart{
      position: absolute;
      right: 10px;


    }
    .el-button:hover{
      border-color: #42b983;
      color: #42b983;
    }
    .el-button{
      background-color: #2C3242;
      border-color: #fff;
      //position: absolute;
      //margin-top: -50px;
      //right: 30px;
    }
    .el-select .el-input{
      width: 100px;
      .el-input__inner{
        text-align: center;
        border: 1px #fff solid;
      }
      .el-input__suffix, .el-input__suffix-inner{
        margin-top: 0px;
      }
    }
    span.wordPage{
      position: relative;
      margin-left: 10px;
    }
    //.el-select.page{
    //  position: absolute;
    //  right: 10px ;
    //}
    span{
      margin-top: 10px;
      font-size: 13px;
      color: #fff;
    }
    span.wordFind{
      margin-left: 5px;
    }
  }
  .search{
    display: flex;
    margin: 0px 10px;
    position: relative;
    align-items: center;
    span{
      margin-top: 10px;
      font-size: 13px;
      color: #fff;
    }
    span.wordFind{
      margin-left: 5px;
    }
    .el-input{
      // margin-left: 10px;
      margin-top: 10px;
      width: 200px;
      .el-input__inner{
        background-color: #303749;
        color: #fff;
        border: 1px #fff solid;
      }
    }
    .el-input .el-input__inner.active{
      border: 1px red solid;
    }
    .el-select .el-input{
      width: 100px;
      .el-input__inner{
        text-align: center;
        border: 1px #fff solid;
      }
      .el-input__suffix, .el-input__suffix-inner{
        margin-top: 0px;
      }
    }
    span.wordPage{
      position: absolute;
      right: 100px;
    }
    .el-select.page{
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }

  .statusTable{
    margin-top: 20px;
    margin-left: 10px;
    margin-right: 10px;
    background-color: #2c3242;
    height: 85%;
    //去除表格最下面那条线
    .el-table::before{
      height: 0px;
    }
    .el-table{
      background-color: #2c3242;
      //去除表头下面那条线
      th.el-table__cell.is-leaf{
        border-bottom: 0px;
      }
      //设置排序图标的颜色
      // .descending .sort-caret.descending {
      //   border-top-color: #359186;
      // }
      // .ascending .sort-caret.ascending {
      //   border-bottom-color: #359186;
      // }
      .cell{
        text-align: center;
      }
      th{
        background-color: #2c3242;
        color: #fff;
        // border-right: 1px solid rgba(256, 256, 256, 0.5);
      }
      tr{
        background-color: #2c3242;
        color: #fff;
        td{
          border-bottom: 0px;
        }
      }
      tr:hover td{
        background-color: rgba(107, 199, 255, 0.98) !important;
      }
    }
  }
  .el-pagination{
    margin-top: 10px;
    display: flex;
    align-items: center; //垂直居中
    ul li{
      background-color: #303749;
      color: #fff;
    }
    ul li.active{
      color: #359186;
    }
    ul li:hover{
      color: #359186;
    }
    .btn-prev{
      background-color: #303749;
      .el-icon{
        color: #fff;
      }
      .el-icon:hover{
        color: #359186;
      }
    }
    .btn-next{
      background-color: #303749;
      .el-icon{
        color: #fff;
      }
      .el-icon:hover{
        color: #359186;
      }
    }
  }
}
</style>
